import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
var _ = require('lodash');


export default class BrandCard extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Col lg={12}>
                <div className="card product-card">
                    <div className="card-block p-3 pos-relative row">
                        <div className="col-md-2 mb-2 mb-md-0">
                            <img className="rounded img-fluid align-center" src={"img/brands/" + this.props.brand.image} alt={this.props.brand.name} />
                        </div>
                        <div className="col-md-10 d-flex flex-column align-items-start">
                            <h4 className="card-title mb-2">
                                {/* <a href="" className="text-grey-dark">{this.props.brand.name}</a> */}
                                {/* <p >{this.props.brand.name}</p> */}
                                <Link className="text-grey-dark" to={"/products/all/" + this.props.brand.linkName}> {this.props.brand.name}</Link>
                            </h4>
                            <p className="text-muted text-md">{this.props.brand.desc}</p>
                        </div>
                    </div>
                </div>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/BrandCard.js